import React from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Grid, Row, Col, Text } from 'shared/components'

import * as styles from './styles'

const InvoiceButtonComponent = ({ onRouteToInvoiceOverview }) => (
  <Grid>
    <Row center="xs">
      <Col xs={12}>
        <Button
          circle
          small
          outlined
          onClick={onRouteToInvoiceOverview}
        >
          <FontAwesomeIcon size="lg" icon="file" css={styles.icon} />
          <Text size={11}>Invoice</Text>
        </Button>
      </Col>
    </Row>
  </Grid>
)

InvoiceButtonComponent.propTypes = {
  onRouteToInvoiceOverview: PropTypes.func,
}

export default InvoiceButtonComponent
